module.exports = __webpack_public_path__ + "static/counsel-16e8e4a3b48d2e8c7686a05188cb5893.png";